import React from 'react';

// Carrusel de imágenes promocionales
function CarruselPromocional() {
  const imagenes = [
    '/assets/banner1.jpg',
    '/assets/banner2.jpg',
    '/assets/banner3.jpg',
    '/assets/banner4.jpg',
  ];
  const [idx, setIdx] = React.useState(0);
  React.useEffect(() => {
    const timer = setInterval(() => setIdx(i => (i + 1) % imagenes.length), 3500);
    return () => clearInterval(timer);
  }, [imagenes.length]);
  return (
    <div style={{width:'100%',height:220,position:'relative',background:'#eee'}}>
      {imagenes.map((img, i) => (
        <img
          key={img}
          src={img}
          alt={`Promocional ${i+1}`}
          style={{
            display: i === idx ? 'block' : 'none',
            width: '100%',
            height: '100%',
            objectFit: 'cover',
            borderRadius: '18px',
            position: 'absolute',
            top: 0,
            left: 0,
            transition: 'opacity 0.7s',
            boxShadow: '0 2px 16px #36d1c422',
          }}
        />
      ))}
    </div>
  );
}
import { useNavigate } from 'react-router-dom';


export default function LandingPage() {
  const navigate = useNavigate();
  return (
    <div className="landingpage-container" style={{background:'#fff'}}>
      <header
        style={{
          width: '100%',
          minHeight: 80,
          background: '#fff',
          borderBottom: '1px solid #eee',
          padding: '18px 0 12px 0',
          marginBottom: 32,
          position: 'relative',
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center',
          justifyContent: 'flex-start',
        }}
      >
        <img src="/logo192.png" alt="Braineka Logo" style={{width:56, height:56, marginLeft:32, marginRight:18, borderRadius:12, boxShadow:'0 2px 8px #36d1c422'}} />
        <div style={{display:'flex', flexDirection:'column', alignItems:'flex-start'}}>
          <h1 style={{marginBottom:2, fontWeight:800, letterSpacing:1, color:'#222', fontSize:'2rem'}}>Braineka</h1>
          <h2 style={{fontWeight:400, color:'#0099cc', marginBottom:0, fontSize:'1.13rem'}}>Aplicación móvil para tratamiento de fobias y miedos</h2>
        </div>
        <div style={{position:'absolute', top:18, right:32, display:'flex', gap:16, zIndex:10}}>
          <a className="btn-orange landing-btn" href="https://admin.braineka.com" target="_blank" rel="noopener noreferrer" style={{background: 'linear-gradient(90deg, #f18618 0%, #ffb347 100%)', color:'#fff', fontWeight:700, borderRadius:14, boxShadow:'0 2px 10px #f1861822', padding:'13px 28px', fontSize:'1.13rem', border:'none'}}>Reg. o Acceso Prof.</a>
          <button className="btn-blue landing-btn" onClick={()=>navigate('/login')} style={{background: 'linear-gradient(90deg, #0099cc 0%, #1e90ff 100%)', color:'#fff', fontWeight:700, borderRadius:14, boxShadow:'0 2px 10px #0099cc22', padding:'13px 28px', fontSize:'1.13rem', border:'none'}}>Entrar</button>
        </div>
      </header>
      <main style={{maxWidth:1000, margin:'0 auto', padding:'0 16px'}}>
        <section style={{marginBottom:32}}>
          <div className="landing-carrusel" style={{width:'100%',maxWidth:600,margin:'0 auto 24px',position:'relative',borderRadius:18,overflow:'hidden',boxShadow:'0 2px 16px #36d1c422'}}>
            <CarruselPromocional />
          </div>
          <div className="landing-marketing" style={{background:'rgba(255,255,255,0.98)', borderRadius:18, boxShadow:'0 4px 24px #36d1c422', padding:'32px 18px', textAlign:'center', margin:'32px auto 24px', maxWidth:600}}>
            <h2 style={{color:'#1e90ff', fontWeight:800, fontSize:'2rem', marginBottom:12}}>Braineka: 16 tratamientos para fobias, miedo, depresión y ansiedad</h2>
            <p style={{fontSize:'1.18rem', color:'#222', marginBottom:18}}>Completamente gratis. Solicítala a tu terapeuta y comienza a mejorar tu calidad de vida hoy mismo.</p>
            <p style={{fontSize:'1.08rem', color:'#0099cc', marginBottom:0}}>¡Innovación en neurotecnología y psicología para tu bienestar!</p>
          </div>



          <div className="landing-table" style={{margin:'0 auto 32px', background:'#f9f9f9', borderRadius:12, boxShadow:'0 2px 8px #0001', padding:24}}>
            <table style={{width:'100%', borderCollapse:'collapse', fontSize:'1.05rem'}}>
              <tbody>
                <tr><td><b>Nombre de la empresa</b></td><td>Braineka</td></tr>
                <tr><td><b>Empresa desarrolladora</b></td><td>Alquímica Quimérica C.A.</td></tr>
                <tr><td><b>Tipo de aplicación</b></td><td>Aplicación móvil para tratamiento de fobias y miedos</td></tr>
                <tr><td><b>Propósito principal</b></td><td>Coadyuvante en el tratamiento de fobias y miedos mediante técnicas de psicología, medicina, neurociencias</td></tr>
                <tr><td><b>Avales</b></td><td>Asociación Latinoamericana de Neurobiofeedback</td></tr>
                <tr><td><b>Tecnología utilizada</b></td><td>Sonidos binaurales, estimulación estroboscópica</td></tr>
                <tr><td><b>Condiciones tratadas</b></td><td>Agorafobia, Acrofobia, Entomofobia, TDA, Banda virtual gástrica, Insomnio, Adicciones, Ludopatía, Ataques de pánico, Depresión, Fobia a los exámenes, Incremento del sistema inmune, Banda Gástrica Digital, Alcohol Free</td></tr>
                <tr><td><b>Características principales</b></td><td>Anónima, eficaz, cómoda, uso en casa</td></tr>
                <tr><td><b>Requisitos de uso</b></td><td>Ambiente oscuro, uso con auriculares, mente despejada, actitud relajada</td></tr>
                <tr><td><b>Contraindicaciones</b></td><td>Epilepsia, ataques convulsivos</td></tr>
                <tr><td><b>Público objetivo</b></td><td>Mayores de edad, niños bajo supervisión de padres o representantes</td></tr>
                <tr><td><b>Enfoque de tratamiento</b></td><td>Desensibilización sistemática, aproximación gradual al objeto fóbico tras relajación</td></tr>
                <tr><td><b>Frecuencia cerebral objetivo</b></td><td>Low Beta (12–14 Hz)</td></tr>
                <tr><td><b>Recomendación médica</b></td><td>Complemento de terapia psicológica, no sustitutivo</td></tr>
                <tr><td><b>Sitio web</b></td><td><a href="https://braineka.com" target="_blank" rel="noopener noreferrer">https://braineka.com</a></td></tr>
                <tr><td><b>Términos legales</b></td><td><a href="https://www.braineka.com/legal-ES" target="_blank" rel="noopener noreferrer">www.braineka.com/legal-ES</a></td></tr>
              </tbody>
            </table>
          </div>
          <div style={{display:'flex', gap:24, justifyContent:'center', marginBottom:32, flexWrap:'wrap'}}>
            <a className="btn-blue" href="https://admin.braineka.com" target="_blank" rel="noopener noreferrer">Login Profesional</a>
          </div>
        </section>
        <section>
          <h2 style={{margin:'32px 0 16px', color:'#1976d2'}}>Condiciones tratadas</h2>
          <div className="condiciones-list" style={{display:'flex', flexWrap:'wrap', gap:24, justifyContent:'center'}}>
            {condicionesData.map((cond, i) => (
              <CondicionCard key={cond.titulo} {...cond} colorClass={colorClasses[i % colorClasses.length]} navigate={navigate} />
            ))}
          </div>
        </section>
      </main>
      <footer className="landingpage-footer">
        &copy; {new Date().getFullYear()} Braineka. Todos los derechos reservados.
      </footer>
    </div>
  );
}

// Colores para los botones y cards
const colorClasses = ['btn-blue','btn-green','btn-red','btn-orange','btn-yellow'];

// Datos de condiciones tratadas
const condicionesData = [
  {
    titulo: 'Claustrofobia',
    slider: ['/assets/claustrofobia1.jpg','/assets/claustrofobia2.jpg','/assets/claustrofobia3.jpg'],
    dsm: 'Miedo intenso y persistente a espacios cerrados o confinados.',
    vivencia: 'Ansiedad, palpitaciones y sensación de ahogo en ascensores, habitaciones pequeñas o túneles.',
    propuesta: 'Exposición gradual, relajación guiada y técnicas de afrontamiento para recuperar la tranquilidad en espacios cerrados.'
  },
  {
    titulo: 'Incremento del sistema inmune',
    slider: ['/assets/inmune1.jpg','/assets/inmune2.jpg','/assets/inmune3.jpg'],
    dsm: 'Técnicas de estimulación para fortalecer defensas naturales.',
    vivencia: 'Mejoría en la respuesta inmunológica y sensación de bienestar.',
    propuesta: 'Relajación guiada y estimulación multisensorial para potenciar el sistema inmune.'
  },
  {
    titulo: 'Miedo a Manejar (Amaxofobia)',
    slider: ['/assets/amaxofobia1.jpg','/assets/amaxofobia2.jpg','/assets/amaxofobia3.jpg'],
    dsm: 'Ansiedad o temor intenso al conducir vehículos.',
    vivencia: 'Evita conducir, siente nerviosismo, palpitaciones o bloqueo al manejar.',
    propuesta: 'Exposición gradual, relajación guiada y técnicas de autocontrol para recuperar la confianza al volante.'
  },
  {
    titulo: 'Banda Gástrica Digital',
    slider: ['/assets/bandadigital1.jpg','/assets/bandadigital2.jpg','/assets/bandadigital3.jpg'],
    dsm: 'Intervención digital para modificar hábitos alimenticios.',
    vivencia: 'Sensación de saciedad y control alimentario sin cirugía.',
    propuesta: 'Terapia multisensorial y sugestión guiada digital.'
  },
  {
    titulo: 'Alcohol Free',
    slider: ['/assets/alcoholfree1.jpg','/assets/alcoholfree2.jpg','/assets/alcoholfree3.jpg'],
    dsm: 'Apoyo para dejar el consumo de alcohol.',
    vivencia: 'Reducción de ansiedad y control de impulsos relacionados con el alcohol.',
    propuesta: 'Técnicas de relajación y neurotecnología para lograr una vida libre de alcohol.'
  },
  {
    titulo: 'Agorafobia',
    slider: ['/assets/agorafobia1.jpg','/assets/agorafobia2.jpg','/assets/agorafobia3.jpg'],
    dsm: 'Ansiedad intensa ante lugares o situaciones donde escapar podría ser difícil.',
    vivencia: 'El paciente evita espacios abiertos o multitudes por miedo a no poder escapar.',
    propuesta: 'Braineka propone exposición gradual y relajación profunda personalizada.'
  },
  {
    titulo: 'Acrofobia',
    slider: ['/assets/acrofobia1.jpg','/assets/acrofobia2.jpg','/assets/acrofobia3.jpg'],
    dsm: 'Miedo marcado y persistente a las alturas.',
    vivencia: 'Sensación de vértigo, ansiedad y evitación de lugares altos.',
    propuesta: 'Tratamiento con desensibilización sistemática y estimulación multisensorial.'
  },
  {
    titulo: 'Entomofobia',
    slider: ['/assets/entomofobia1.jpg','/assets/entomofobia2.jpg','/assets/entomofobia3.jpg'],
    dsm: 'Miedo irracional y persistente a los insectos.',
    vivencia: 'Reacciones de pánico ante la presencia o imagen de insectos.',
    propuesta: 'Exposición gradual y técnicas de relajación guiada.'
  },
  {
    titulo: 'TDA (Déficit de Atención)',
    slider: ['/assets/tda1.jpg','/assets/tda2.jpg','/assets/tda3.jpg'],
    dsm: 'Patrón persistente de inatención y/o hiperactividad-impulsividad.',
    vivencia: 'Dificultad para concentrarse, inquietud y olvidos frecuentes.',
    propuesta: 'Entrenamiento de atención y relajación con neurotecnología.'
  },
  {
    titulo: 'Insomnio',
    slider: ['/assets/insomnio1.jpg','/assets/insomnio2.jpg','/assets/insomnio3.jpg'],
    dsm: 'Dificultad para iniciar o mantener el sueño.',
    vivencia: 'Cansancio diurno, irritabilidad y preocupación por el sueño.',
    propuesta: 'Relajación profunda y reentrenamiento del ciclo de sueño.'
  },
  {
    titulo: 'Ludopatía',
    slider: ['/assets/ludopatia1.jpg','/assets/ludopatia2.jpg','/assets/ludopatia3.jpg'],
    dsm: 'Juego patológico, incapacidad de controlar el impulso de apostar.',
    vivencia: 'Preocupación constante por el juego y deterioro de la vida social.',
    propuesta: 'Técnicas de autocontrol y relajación profunda.'
  },
  {
    titulo: 'Ataques de pánico',
    slider: ['/assets/panico1.jpg','/assets/panico2.jpg','/assets/panico3.jpg'],
    dsm: 'Episodios súbitos de miedo intenso y síntomas físicos.',
    vivencia: 'Palpitaciones, sudoración, sensación de muerte inminente.',
    propuesta: 'Entrenamiento en control de síntomas y relajación.'
  },
  {
    titulo: 'Depresión',
    slider: ['/assets/depresion1.jpg','/assets/depresion2.jpg','/assets/depresion3.jpg'],
    dsm: 'Estado de ánimo deprimido y pérdida de interés o placer.',
    vivencia: 'Tristeza persistente, baja energía y autoestima.',
    propuesta: 'Apoyo emocional y técnicas de activación conductual.'
  },
  {
    titulo: 'Fobia a los exámenes',
    slider: ['/assets/examen1.jpg','/assets/examen2.jpg','/assets/examen3.jpg'],
    dsm: 'Ansiedad intensa ante situaciones de evaluación.',
    vivencia: 'Bloqueo mental, miedo al fracaso y síntomas físicos.',
    propuesta: 'Preparación mental y relajación guiada antes de exámenes.'
  },
];

function CondicionCard({ titulo, slider, dsm, vivencia, propuesta, colorClass, navigate }) {
  const [slideIdx, setSlideIdx] = React.useState(0);
  React.useEffect(() => {
    const timer = setInterval(() => setSlideIdx(idx => (idx + 1) % slider.length), 3000);
    return () => clearInterval(timer);
  }, [slider.length]);
  // Recibe navigate como prop
  return (
    <div className={`cond-card ${colorClass}`} style={{width:320, borderRadius:12, background:'#fff', boxShadow:'0 2px 8px #0001', padding:20, marginBottom:24}}>
      <div className="slider" style={{width:'100%',height:180,overflow:'hidden',borderRadius:8,marginBottom:16,background:'#eee',position:'relative'}}>
        {slider.map((img, i) => (
          <div key={img} className="slide" style={{display: i===slideIdx?'block':'none',width:'100%',height:'100%'}}>
            <img src={img} alt={titulo+ ' slide'} style={{width:'100%',height:'100%',objectFit:'cover',borderRadius:8}} />
          </div>
        ))}
      </div>
      <h3 style={{margin:'8px 0 8px',color:'#1976d2'}}>{titulo}</h3>
      <div style={{fontSize:'1.05rem',marginBottom:8}}><b>Descripción breve:</b> {dsm}</div>
      <div style={{fontSize:'1.05rem',marginBottom:8}}><b>Vivencia:</b> {vivencia}</div>
      <div style={{fontSize:'1.05rem',marginBottom:16}}><b>Propuesta Braineka:</b> {propuesta}</div>
      <button className="btn-blue neon-orange" style={{width:'100%',marginTop:8,background:'linear-gradient(90deg, #0099cc 0%, #1e90ff 100%)',color:'#fff',fontWeight:700,borderRadius:14,boxShadow:'0 0 12px 2px #f18618, 0 2px 10px #0099cc22',border:'none',fontSize:'1.08rem',padding:'12px 0',transition:'box-shadow 0.2s'}} onClick={()=>navigate('/contacto')}>Solicitar Info</button>
    </div>
  );
}
